import React from 'react';
import {Outlet} from 'react-router-dom';

/**
 * Dashboard layout wrapper - renders child routes via Outlet.
 * This is the parent route component for /dashboard.
 * Child routes (main, entry, store) render inside the Outlet.
 */
export const DashboardLayout: React.FC = () => {
    return <Outlet />;
};
